jQuery(document).ready(function() {
  var ctr = 0;
  pickerTriggerFunction();

  function pickerTriggerFunction() {
    var pickerTrigger = setInterval(function() {
      // console.log(ctr++);
      if(jQuery(".ui-datepicker-today").length > 0) {
        jQuery(".ui-datepicker-calendar td").click(function() {
          pickerTriggerFunction();
        });
        jQuery("td.ui-datepicker-today").click(function(){
          jQuery(".popup").show();
          jQuery(".popup-overlay").show();
        });
        clearInterval(pickerTrigger);
      }
    },200);
  }

  jQuery(".close-popup").click(function() {
    jQuery(".popup").hide();
    jQuery(".popup-overlay").hide();
  });
});

